import React, { useEffect, useState, createContext,useContext } from "react";
import {
  withRouter,
  RouteComponentProps,
  useHistory,
  Link,
  useLocation,
  useRouteMatch
} from "react-router-dom";
import { LoadingIndicator } from "../../components/LoadingIndicator";
import { Colors, Spacing, UIRelatedConstants } from "../../theme/Theme";
import { RoutePathConstant, roleNameEnum, getEffectiveRoleName } from "../../util/Common";
import { RBAlert, RBErrorAlert } from "../../components/RBAlert";
import { AlertInfoProps } from "../../interfacesProps/AlertInfoProps";
import { RBButton, RBButtonType } from "../../components/RBButton";
import { ErrorMessageProps } from "../../interfacesProps/ErrorMessageProps";
import { useLastLocation } from "react-router-last-location";
import { RBContext } from "../../components/RBContext";
import { IndustryModeEnum } from "../../api/constants";
import { AuthService } from "../../api/AuthService";
import { PharmacyService } from "../../api/PharmacyService";
import { RBShiftLayoutCardForApplicant } from "../../components/RBShiftLayoutCardForApplicant";
import { ColumnStyle } from "../../theme/ComponentTheme";
import { RBCardView } from "../../components/RBCardView";
import { RBAppbar } from "../../components/RBAppbar";
import { Checkbox } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import { RBModal } from "../../components/RBModal";
import { RBEmptyBlock } from "../../components/RBEmptyBlock";
import moment from 'moment-timezone';
import { formatWorkerType } from "../../util/FormattingService";
import { AccountInfoContext } from "../../components/AccountInfoContext";

const useStyles = makeStyles({
  Card: {
    "&:hover": {
      cursor: "pointer",
    },
  },
  CardContent: {
    paddingTop: 8,
    "&:last-child": {
      paddingBottom: 8,
    },
  },
});

interface ApplicantsShiftPageWithoutRouteProps {}

const ApplicantsShiftPageWithoutRoute: React.FC<ApplicantsShiftPageWithoutRouteProps> = ({
  ...props
}) => {
  const {industryMode, primaryColor,secondaryColor,updateprimaryColor,updateSecondaryColor,updateContactEmail,updateContactPhone,updateMode } = useContext(RBContext);

  const [isAlertShowing, setShiftAlertShowing] = useState(false);
  const [shiftAlertInfo, setShiftAlertInfo] = useState<AlertInfoProps>({});
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [submitErrorMessage, setSubmitErrorMessage] = useState<
    ErrorMessageProps
  >();
  const location = useLocation<{
    account: any;
    userId: any;
    pharmacist: any;
    pharmacy: any;
  }>();
  
  const history = useHistory();
  const classes = useStyles();

  const lastLocation = useLastLocation();
  const [account, setAccount] = useState<any>([]);
  const [userId, setUserId] = useState<string>(location.state.userId);
  const [shifts, setShifts] = useState<any[]>([]);
  const [roleName, _] = useState<string>(AuthService.getRoleName());
  const effectiveRoleName = getEffectiveRoleName(account, roleName);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedShifts, setSelectedShifts] = useState<any>({});
  const [disabledButtons, setDisabledButtons] = useState(true);
  const [acceptLoading, setAcceptLoading] = useState(false);
  const [denyLoading, setDenyLoading] = useState(false);
  const [selectedShiftIds, setSelectedShiftIds] = useState<any[]>([]);
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  
  const {accountInformation} = useContext(AccountInfoContext);
  
  console.log("current worker userId ",userId);

  const onClickShiftCard = (shiftId: string) => {
    const item = document.querySelector(".restore-" + shiftId);

    history.push(`${RoutePathConstant.ShiftDetail}${shiftId}`, {
      shiftId: shiftId,
      scrollY: window.scrollY,
    });
    console.log(
      "shift onClickShiftCard id ",
      shiftId,
      window.scrollY,
      item?.getBoundingClientRect()
    );
  };
 

  // Update Account Information as it changes
  useEffect(() => {
    if(accountInformation) {
      setAccount(accountInformation);
    }
  }, [accountInformation]);


  useEffect(() => {

    (async () => {
      await updateprimaryColor( localStorage.getItem('primaryColor')); 
      await updateSecondaryColor( localStorage.getItem('secondaryColor')); 
      await updateContactEmail( localStorage.getItem('contactEmail')); 
      await updateContactPhone( localStorage.getItem('contactPhone')); 
      await updateMode(localStorage.getItem('industryMode')); 
      try {
       
      const data = await PharmacyService.getShiftsByApplicant(location.state.pharmacy.id,location.state.userId);
      const newData = data.data.data;
      newData.sort((a:any, b:any) => {
        return b.shiftToRequests.length - a.shiftToRequests.length;
      });

      setShifts(newData)
    } catch (err) {
        const e: any = err as any;
        setSubmitErrorMessage(e.response ? e.response.data.message : e.message);
        console.log("LocationApplicantsPageWithoutRouter error", err);
      } finally {
        setIsPageLoading(false);
      }

  })(); 
    
  }, []);

  console.log("current passed shifts ",shifts)

  // shifts that actually have requests (eligible for selection)
  const shiftsWithRequests = shifts.filter((shift: any) => (shift.shiftToRequests || []).length > 0);
  const shiftsWithRequestsLength = shiftsWithRequests.length;


 // Toggle selection of a shift
 const toggleShiftSelection = (index:any, shiftId:any) => {
  const newSelectedShifts:any = { ...selectedShifts };
  const newSelectedShiftIds:any = [...selectedShiftIds];

  newSelectedShifts[index] = !newSelectedShifts[index];

  if (newSelectedShifts[index]) {
    newSelectedShiftIds.push(shiftId);
  } else {
    const shiftIndex = newSelectedShiftIds.indexOf(shiftId);
    if (shiftIndex !== -1) {
      newSelectedShiftIds.splice(shiftIndex, 1);
    }
  }

  const disabledButtons = Object.values(newSelectedShifts).every((value) => !value); // Disable buttons if no shift is selected
  const shiftsWithRequests = shifts.filter((shift:any) => shift.shiftToRequests.length > 0);
const shiftsWithRequestsLength = shiftsWithRequests.length;

  const newSelectAll = shiftsWithRequestsLength > 0 && newSelectedShiftIds.length === shiftsWithRequestsLength; // Check if all eligible shifts are selected
  setSelectedShifts(newSelectedShifts)
  setSelectedShiftIds(newSelectedShiftIds)
  setDisabledButtons(disabledButtons)
  setSelectAll(newSelectAll)
 
};

// Toggle "Select All" checkbox
const toggleSelectAll = () => {

  const newSelectedShifts:any = {};
  const newSelectedShiftIds:any = [];

  // If "Select All" is currently checked, uncheck all and disable buttons
  if (selectAll) {
    Object.keys(selectedShifts).forEach((key) => {
      newSelectedShifts[key] = false;
    });
    setSelectedShifts(newSelectedShifts)
    setSelectedShiftIds([])
    setDisabledButtons(true)
    setSelectAll(false)
  } else { // Otherwise, check all eligible shifts and enable buttons only for them
    shifts.forEach((shift:any, index:any) => {
      const eligible = (shift.shiftToRequests || []).length > 0;
      newSelectedShifts[index] = eligible;
      if (eligible) {
        newSelectedShiftIds.push(shift.id); // Store the ID of each selected (eligible) shift
      }
    });
    setSelectedShifts(newSelectedShifts)
    setSelectedShiftIds(newSelectedShiftIds)
    setDisabledButtons(newSelectedShiftIds.length === 0)
    setSelectAll(newSelectedShiftIds.length > 0 && newSelectedShiftIds.length === shiftsWithRequestsLength)

  }
};

const selectPharmacist = async () => {

  if (acceptLoading) {
    return;
  }
  setAcceptLoading(true)
  setShowAcceptModal(false)
  try {
    console.log("selectedShiftIds",selectedShiftIds)
    await PharmacyService.acceptApplicantBulk(selectedShiftIds,location.state.userId);
    setShiftAlertInfo({
      title: "Success",
      message: "Successfully selected applicant!",
      buttons: [
        <RBButton
          key={"ok"}
          onClick={() => {
            setShiftAlertShowing(false);
            history.push("/dashboard");
          }}
          text="Home"
          buttonBackgroundColor={secondaryColor}
        />,
      ],
    });
    setShiftAlertShowing(true);
    
  } catch (error) {
    const violation = (error as any)?.response ? (error as any).response.data : null;

    // Preserve original specific checks, then add minimal fallback to show server message
    if (
      violation &&
      violation.error &&
      violation.error.includes('No request exists from this user for this shift')
    ) {
      setShiftAlertInfo({
        title: "The worker is not available any more",
        message: "Please select a different worker and try again.",
        buttons: [
          <RBButton
            key={"ok"}
            onClick={() => {
              setShiftAlertShowing(false);
            }}
            text="Ok"
            buttonBackgroundColor={secondaryColor}
          />,
        ],
      });
      setShiftAlertShowing(true);
    } else if (violation && violation.error && violation.error.includes('conflicted shift')) {
      setShiftAlertInfo({
        title: "Conflicted shift",
        message: "This worker has a conflicted shift.",
        buttons: [
          <RBButton
            key={"ok"}
            onClick={() => {
              setShiftAlertShowing(false);
            }}
            text="Ok"
            buttonBackgroundColor={secondaryColor}
          />,
        ],
      });
      setShiftAlertShowing(true);
    } else if (violation && (violation.error || violation.message)) {
      // Minimal fallback: show whatever the server returned
      setShiftAlertInfo({
        title: "Unable to select applicant",
        message: violation.message || violation.error,
        buttons: [
          <RBButton
            key={"ok"}
            onClick={() => {
              setShiftAlertShowing(false);
            }}
            text="Ok"
            buttonBackgroundColor={secondaryColor}
          />,
        ],
      });
      setShiftAlertShowing(true);
    }
  } finally {
    setAcceptLoading(false)
  }
};

const rejectPharmacist = async() => {

  if (denyLoading) {
    return;
  }
  setDenyLoading(true)
  setShowRejectModal(false)
  try {
    console.log("selectedShiftIds",selectedShiftIds)
   let response = await PharmacyService.rejectApplicantBulk(selectedShiftIds,location.state.userId);
    setShiftAlertInfo({
      title: "Success",
      message: "Successfully rejected applicant!",
      buttons: [
        <RBButton
          key={"ok"}
          onClick={() => {
            setShiftAlertShowing(false);
            history.push("/dashboard");
          }}
          text="Home"
          buttonBackgroundColor={secondaryColor}
        />,
      ],
    });
    setShiftAlertShowing(true);
    
  } catch (error) {
    const violation = (error as any)?.response ? (error as any).response.data : null;

    if (violation && (violation.error || violation.message)) {
      setShiftAlertInfo({
        title: "Unable to reject applicant",
        message: violation.message || violation.error,
        buttons: [
          <RBButton
            key={"ok"}
            onClick={() => {
              setShiftAlertShowing(false);
            }}
            text="Ok"
            buttonBackgroundColor={secondaryColor}
          />,
        ],
      });
      setShiftAlertShowing(true);
    }
  } finally {
   setDenyLoading(false)
  }
};



const onAcceptClose = () => {
  setShowAcceptModal(false);
}
const onRejectClose= () => {
  setShowRejectModal(false);
}
// Show an RBAlert (same style as ViewApplicants onSelection) for accept confirmation
const showAcceptAlert = () => {
  const name = `${location.state.pharmacist.firstName} ${location.state.pharmacist.lastName}`;
  const workerType = formatWorkerType(location.state.pharmacist.type);

  // single selection message (HTML string)
  if (selectedShiftIds.length === 1) {
    const shiftId = selectedShiftIds[0];
    const shift = shifts.find((s: any) => s.id === shiftId);
    if (!shift) return;
    const req = (shift.shiftToRequests || []).find((r: any) => {
      return r.pharmacistId === location.state.userId || r.userId === location.state.userId || r.pharmacist?.id === location.state.userId;
    }) || (shift.shiftToRequests && shift.shiftToRequests[0]) || null;

    const tz = shift.shiftTimeZone || shift.pharmacy?.address?.timezone || 'UTC';
    const startRaw = req?.requestedStartTime || shift.officialStartTime;
    const endRaw = req?.requestedEndTime || shift.officialEndTime;
    const start = startRaw ? moment.tz(startRaw, tz).format('ddd, MMM Do YYYY h:mm a') : 'N/A';
    const end = endRaw ? moment.tz(endRaw, tz).format('ddd, MMM Do YYYY h:mm a') : 'N/A';
    const wage = req?.requestedWage ? `$${(req.requestedWage / 100).toFixed(2)}` : shift.wage ? `$${(shift.wage / 100).toFixed(2)}` : 'N/A';

    const message = `Hire ${name} ${workerType} for <strong>${start}</strong> – <strong>${end}</strong> at a wage of <strong>${wage}</strong>`;
    setShiftAlertInfo({
      title: `Confirm ${workerType}`,
      alertWidth: 520,
      message,
      buttons: [
        <RBButton
          key="Cancel"
          onClick={() => setShiftAlertShowing(false)}
          buttonType={RBButtonType.cancel}
          text="Cancel"
        />,
        <RBButton
          key="Confirm"
          onClick={async () => {
            setShiftAlertShowing(false);
            await selectPharmacist();
          }}
          text="Confirm"
          style={{ background: primaryColor }}
        />,
      ],
    });
    setShiftAlertShowing(true);
    return;
  }

  // multiple selection: build an HTML string with header and list
  if (selectedShiftIds.length > 1) {
  const tzDefault = 'UTC';
    let html = `Hire ${name} ${workerType} for the following shifts:`;
    html += '<br/>';
    selectedShiftIds.forEach((sid: any) => {
      const shift = shifts.find((s: any) => s.id === sid);
      if (!shift) return;
      const req = (shift.shiftToRequests || []).find((r: any) => {
        return r.pharmacistId === location.state.userId || r.userId === location.state.userId || r.pharmacist?.id === location.state.userId;
      }) || (shift.shiftToRequests && shift.shiftToRequests[0]) || null;
      const tz = shift.shiftTimeZone || shift.pharmacy?.address?.timezone || tzDefault;
      const startRaw = req?.requestedStartTime || shift.officialStartTime;
      const endRaw = req?.requestedEndTime || shift.officialEndTime;
      const start = startRaw ? moment.tz(startRaw, tz).format('ddd, MMM Do YYYY h:mm a') : 'N/A';
      const end = endRaw ? moment.tz(endRaw, tz).format('ddd, MMM Do YYYY h:mm a') : 'N/A';
      const wage = req?.requestedWage ? `$${(req.requestedWage / 100).toFixed(2)}` : shift.wage ? `$${(shift.wage / 100).toFixed(2)}` : 'N/A';
      const locationName = shift.pharmacy?.displayName || shift.pharmacy?.name || shift.location || 'Location';
      html += `<div style="margin-top:8px;color:#666">${locationName}: <strong> ${start}</strong> – <strong>${end}</strong> at a wage of<strong> ${wage}</strong>.</div>`;
    });

    setShiftAlertInfo({
      title: `Confirm ${workerType}`,
      message: html,
      buttons: [
        <RBButton
          key="Cancel"
          onClick={() => setShiftAlertShowing(false)}
          buttonType={RBButtonType.cancel}
          text="Cancel"
        />,
        <RBButton
          key="Confirm"
          onClick={async () => {
            setShiftAlertShowing(false);
            await selectPharmacist();
          }}
          text="Confirm"
          style={{ background: primaryColor }}
        />,
      ],
    });
    // For multiple selections, open the wider RBModal instead of the RBAlert so our modalWidth is applied
    setShowAcceptModal(true);
  }
};
// Show an RBAlert (same style as ViewApplicants onReject) for reject confirmation
const showRejectAlert = () => {
  const name = `${location.state.pharmacist.firstName} ${location.state.pharmacist.lastName}`;
  const workerType = formatWorkerType(location.state.pharmacist.type);

  // single selection message
  if (selectedShiftIds.length === 1) {
    const shiftId = selectedShiftIds[0];
    const shift = shifts.find((s: any) => s.id === shiftId);
    if (!shift) return;

    const message = `Candidate ${name} will no longer be eligible for this shift.`;
    setShiftAlertInfo({
      title: `Reject ${workerType}`,
      alertWidth: 520,
      message,
      buttons: [
        <RBButton
          key="Cancel"
          onClick={() => setShiftAlertShowing(false)}
          buttonType={RBButtonType.cancel}
          text="Cancel"
        />,
        <RBButton
          key="Confirm"
          onClick={async () => {
            setShiftAlertShowing(false);
            await rejectPharmacist();
          }}
          text="Confirm"
          style={{ background: primaryColor }}
        />,
      ],
    });
    setShiftAlertShowing(true);
    return;
  }

  // multiple selection: use the same simple modal text as the modal UI (no per-shift listing)
  if (selectedShiftIds.length > 1) {
    const message = `Candidate ${name} will no longer be eligible for these shifts.`;
    setShiftAlertInfo({
      title: `Reject ${workerType}`,
      message,
      buttons: [
        <RBButton
          key="Cancel"
          onClick={() => setShiftAlertShowing(false)}
          buttonType={RBButtonType.cancel}
          text="Cancel"
        />,
        <RBButton
          key="Confirm"
          onClick={async () => {
            setShiftAlertShowing(false);
            await rejectPharmacist();
          }}
          text="Confirm"
          style={{ background: primaryColor }}
        />,
      ],
    });
    // For multiple selections, open the wider RBModal instead of the RBAlert so our modalWidth is applied
    setShowRejectModal(true);
  }
};
const renderAcceptModalContent = () => {
  const name = `${location.state.pharmacist.firstName} ${location.state.pharmacist.lastName}`;

  // Helper to render a single shift line (used for multiple selection list)
  const renderShiftLine = (shift: any, idx: number) => {
    if (!shift) return null;
    const req = (shift.shiftToRequests || []).find((r: any) => {
      return (
        r.pharmacistId === location.state.userId ||
        r.userId === location.state.userId ||
        r.pharmacist?.id === location.state.userId
      );
    }) || (shift.shiftToRequests && shift.shiftToRequests[0]) || null;

    const tz = shift.shiftTimeZone || shift.pharmacy?.address?.timezone || 'UTC';
    const startRaw = req?.requestedStartTime || shift.officialStartTime;
    const endRaw = req?.requestedEndTime || shift.officialEndTime;
    const start = startRaw ? moment.tz(startRaw, tz).format('ddd, MMM Do YYYY h:mm a') : 'N/A';
    const end = endRaw ? moment.tz(endRaw, tz).format('ddd, MMM Do YYYY h:mm a') : 'N/A';
    const wage = req?.requestedWage
      ? `$${(req.requestedWage / 100).toFixed(2)}`
      : shift.wage
      ? `$${(shift.wage / 100).toFixed(2)}`
      : 'N/A';

    const locationName = shift.pharmacy?.displayName || shift.pharmacy?.name || shift.location || 'Location';

    return (
      <div key={`shift-line-${idx}`} style={{ marginBottom: Spacing.medium }}>
        <div style={{ color: Colors.darkGrey }}>
          {locationName}: <strong>{start}</strong> – <strong>{end}</strong> at a wage of <strong>{wage}</strong>.
        </div>
      </div>
    );
  };

  const singleSelected = selectedShiftIds.length === 1;
  let singleConfirmationMessage: string | null = null;

  if (singleSelected) {
    const shiftId = selectedShiftIds[0];
    const shift = shifts.find((s: any) => s.id === shiftId);
    if (shift) {
      const req = (shift.shiftToRequests || []).find((r: any) => {
        return (
          r.pharmacistId === location.state.userId ||
          r.userId === location.state.userId ||
          r.pharmacist?.id === location.state.userId
        );
      }) || (shift.shiftToRequests && shift.shiftToRequests[0]) || null;

      const tz = shift.shiftTimeZone || shift.pharmacy?.address?.timezone || 'UTC';
      const startRaw = req?.requestedStartTime || shift.officialStartTime;
      const endRaw = req?.requestedEndTime || shift.officialEndTime;
      const start = startRaw ? moment.tz(startRaw, tz).format('ddd, MMM Do YYYY h:mm a') : 'N/A';
      const end = endRaw ? moment.tz(endRaw, tz).format('ddd, MMM Do YYYY h:mm a') : 'N/A';
      const wage = req?.requestedWage
        ? `$${(req.requestedWage / 100).toFixed(2)}`
        : shift.wage
        ? `$${(shift.wage / 100).toFixed(2)}`
        : 'N/A';

      singleConfirmationMessage = `Hire ${name} ${formatWorkerType(location.state.pharmacist.type)} for <strong>${start}</strong> – <strong>${end}</strong> at a wage of <strong>${wage}</strong>`;
    }
  }

  // Build multiple selection details if more than one selected
  const multipleDetails = selectedShiftIds.length > 1 ? (
    <div>
      {selectedShiftIds.map((sid: any, idx: number) => {
        const shift = shifts.find((s: any) => s.id === sid);
        return renderShiftLine(shift, idx);
      })}
    </div>
  ) : null;

  return (
    <div
      style={{
        backgroundColor: Colors.defaultGrey,
        display: "flex",
        flex: 1,
      }}
    >
      <RBCardView
        style={{
          flex: 1,
          marginLeft: Spacing.large,
          marginRight: Spacing.large,
          marginBottom: Spacing.smallest,
          paddingLeft: Spacing.large,
          paddingTop: Spacing.large,
          paddingRight: Spacing.large,
          paddingBottom: Spacing.large,
        }}
      >
        {/* If single selection, show the detailed single message (matching ViewApplicants alert); otherwise show the list */}
        {singleSelected && singleConfirmationMessage && (
          <div dangerouslySetInnerHTML={{ __html: singleConfirmationMessage }} />
        )}
        {selectedShiftIds.length > 1 && (
          <div>
            <div style={{ marginBottom: Spacing.large * 1 }}>
              Hire {name} {formatWorkerType(location.state.pharmacist.type)} for the following shifts:
            </div>
            {multipleDetails}
          </div>
        )}

        <br />
        <div
          style={{
            display: "flex",
            flex: 1,
            alignItems: "flex-end",
          }}
        >
          <RBButton
            key="Cancel"
            onClick={() => setShowAcceptModal(false)}
            buttonType={RBButtonType.cancel}
            text="Cancel"
            style={{
              display: "flex",
              flex: 1,
              padding: Spacing.medium,
              margin: Spacing.large,
            }}
          />
          <RBButton
            key="Confirm"
            onClick={() => selectPharmacist()}
            text="Confirm"
            isLoading={acceptLoading}
            style={{
              display: "flex",
              flex: 1,
              padding: Spacing.medium,
              margin: Spacing.large,
              background: primaryColor,
            }}
          />
        </div>
      </RBCardView>
    </div>
  );
};
const renderRejectModalContent = () => {
  const name = `${location.state.pharmacist.firstName} ${location.state.pharmacist.lastName}`;
  return (
    <div
      style={{
        backgroundColor: Colors.defaultGrey,
        display: "flex",
        flex: 1,
      }}
    >
      
        <RBCardView
          style={{
            flex: 1,
            marginLeft: Spacing.large,
            marginRight: Spacing.large,
            marginBottom: Spacing.smallest,
            paddingLeft: Spacing.large,
            paddingTop: Spacing.large,
            paddingRight: Spacing.large,
            paddingBottom: Spacing.large,
          }}
        >
         <div>
         Candidate <strong>{name}</strong> will no longer be eligible for <strong>{selectedShiftIds.length > 1 ? "these shifts" : "this shift"}</strong>.
         </div>
         <br></br>
         <div style={{
          display: "flex",
          flex: 1,
          alignItems: "flex-end",
        }}>
              <RBButton
                buttonBackgroundColor={primaryColor}
                text="Confirm"
                onClick={() => rejectPharmacist()}
                style={{
                  display: "flex",
                  flex: 1,
                  padding: Spacing.medium,
                  margin: Spacing.large,
                }}
              />
              <RBButton
                buttonBackgroundColor={primaryColor}
                isLoading={isButtonLoading}
                text="Cancel"
                onClick={() => {
                  setShowRejectModal(false)
                  }
                }
                style={{
                  display: "flex",
                  flex: 1,
                  padding: Spacing.medium,
                  margin: Spacing.large,
                }}
              />
         </div>
        </RBCardView>
     
    </div>
  );
};


 

  return (
    <>
      <RBAlert
        show={isAlertShowing}
        alertTitle={shiftAlertInfo.title}
        alertMessage={shiftAlertInfo.message}
        buttons={shiftAlertInfo.buttons}
        alertWidth={shiftAlertInfo.alertWidth}
      />
     <RBModal
       open={showAcceptModal}
       onClose={onAcceptClose}
         modalTitle={`Confirm ${formatWorkerType(location.state.pharmacist.type)}`}
  // slightly reduced width to better fit content and avoid right-side white space
  modalWidth={selectedShiftIds.length > 1 ? 720 : 600}
          header={
            <RBEmptyBlock
              style={{
                width: "100%",
                height: Spacing.large,
                backgroundColor: Colors.defaultGrey,
                flexShrink: 0,
              }}
            />
          }
          children={
            renderAcceptModalContent()
          }
        />
        <RBModal
          open={showRejectModal}
          onClose={onRejectClose}
            modalTitle={`Reject ${formatWorkerType(location.state.pharmacist.type)}`}
            // slightly reduced width to better fit content
            modalWidth={selectedShiftIds.length > 1 ? 660 : 600}
          header={
            <RBEmptyBlock
              style={{
                width: "100%",
                height: Spacing.large,
                backgroundColor: Colors.defaultGrey,
                flexShrink: 0,
              }}
            />
          }
          children={
            renderRejectModalContent()
          }
        />

         {isPageLoading ? (
        <LoadingIndicator />
      ) : (
        <>
        {shifts.length > 0 && 
        <>
            <div style={{minHeight:"45%",maxHeight:"80%",overflowY: "auto", paddingTop: Spacing.large }}>
              <div
                style={{
                  paddingLeft: Spacing.large,
                  paddingRight: Spacing.large,
                  paddingBottom: Spacing.medium,
                }}
              >
                <Card
                  variant="outlined"
                  className={classes.Card}
                  style={{
                    borderRadius: UIRelatedConstants.CardBorderRadius,
                    borderWidth: 3,
                    // keep the existing border color; only change background when there are no eligible shifts
                    borderColor: primaryColor,
                    backgroundColor: shiftsWithRequestsLength === 0 ? Colors.defaultGrey : undefined,
                  }}
                >
                  <CardContent className={classes.CardContent} onClick={() =>
                        toggleSelectAll()
                      }>
                    <div style={{ display: "flex", flexDirection: "row",marginLeft:-10}}>
                      <Checkbox
                        checked={selectAll}
                        disabled={shiftsWithRequestsLength === 0}
                        style={{
                          color: selectAll ? secondaryColor : Colors.darkGrey,
                        }}
                      onChange={() =>
                        toggleSelectAll()
                      }
                      /> 
                      <span style={{marginTop:10}}>Select All</span>
                    </div>
                  </CardContent>
                </Card>
              </div>
              {shifts?.map((shift: any,index:any) => (
                <>
                  <div key={shift.id} className={`restore-${shift.id}`}>
                    <RBShiftLayoutCardForApplicant
                      key={index}
                      shift={shift}
                      onClick={onClickShiftCard}
                      rolename={effectiveRoleName}
                      account={account}
                      selected={!!selectedShifts[index]}
                      toggleShiftSelection={() => toggleShiftSelection(index,shift.id)}
                      userId={userId}
                    />
                  </div>

                </>
              ))}

            </div>
          <div style={{ 
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              paddingBottom: Spacing.medium,bottom: 0}}>
              <RBButton
              isLoading={acceptLoading}
                style={{
                  display: "flex",
                  flex: 1,
                  padding: Spacing.medium,
                  margin: Spacing.large,
                }}
                disabled={disabledButtons || denyLoading}
                buttonBackgroundColor={secondaryColor}
                onClick={() => {
                  showAcceptAlert();
                }}
                text="Select"
              />
              <RBButton
                style={{
                  display: "flex",
                  flex: 1,
                  padding: Spacing.medium,
                  margin: Spacing.large,
                }}
                isLoading={denyLoading}
                disabled={disabledButtons || acceptLoading}
                buttonBackgroundColor={primaryColor}
                onClick={() => {
                  showRejectAlert();
                }}
                text="Ignore"
              />
            </div>
        </>}
        {shifts.length === 0 && (
          <RBCardView
            marginHorizontal={Spacing.medium}
            style={{
              padding: Spacing.large,
              marginTop: Spacing.medium,
            }}
          >
           No items found.
          </RBCardView>
        )}
        </>
         
      )}
    </>
  );
};

export const ApplicantsShiftPage = withRouter(ApplicantsShiftPageWithoutRoute);
